<template>
  <div class="price-list">
    <ul class="price-list__images">
      <li
        class="price-list__image"
        v-for="(page, index) in pages"
        :key="getKey(page, index)"
        v-lazy-container="{ selector: 'img' }"
      >
        <img :data-src="getImageSource(page, index)" />
      </li>
    </ul>
    <div class="price-list__fab">
      <fab @click.prevent="onBack" />
    </div>
  </div>
</template>

<script>
import Fab from "../components/Fab";

export default {
  name: "PriceListModule",

  components: {
    Fab,
  },

  props: {
    pages: { type: Array },
    windowInnerHeight: { type: String },
  },

  methods: {
    onBack() {
      this.$emit("back");
    },

    getKey(page, index) {
      return (page && page.id) || index;
    },

    getImageSource(page) {
      return page && page.downloadUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  opacity: 0;
  &[lazy="loaded"],
  &[lazy="error"] {
    @include animate-scale-fade-in;
  }
  &[lazy="loading"] {
    width: 100%;
    height: 100vw;
  }
}
.price-list__fab {
  @include animate-float-fade-in;
  position: fixed;
  right: $size-space-1;
  bottom: $size-space-2;
}
.price-list__images {
  margin-top: $size-space-1;
  margin-bottom: $size-space-5;
  padding: 0 $size-space-1;

  .price-list__image {
    margin: 8px 0;

    &:first-child {
      margin-top: 0;
    }
  }
}
</style>
